<template>
  <div class="propertyManageList">
    <div class="filters">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-input class="searchInput" v-model="input" :placeholder="$t('lang.pla_accountOrname')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit()">{{$t('lang.btn_search')}}</el-button>
        <el-button type="success" @click="download()">{{$t('lang.btn_downloadTemplate')}}</el-button>
        <el-upload
          class="upload-demo"
          ref="uploading"
          :on-remove="handleRemove"
          :on-change="handleSuccess"
          :on-error="uploadErr1"
          accept=".xlsx, .xls"
          action
          :file-list="fileList"
          :limit="1"
          :auto-upload="false"
        >
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <el-button
            style="margin-left: 10px;"
            size="small"
            type="success"
            @click="submitUpload"
          >上传到服务器</el-button>
        </el-upload>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addpropertyManage')}}</el-button>
      <el-button type="primary" slot="header" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.propertyManageListCheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="id" label="id"></el-table-column>
        <el-table-column prop="idNo" :label="$t('lang.lbl_duties_note')"></el-table-column>
        <el-table-column prop="mobile" :label="$t('lang.lbl_duties_mobile')">
          <template slot-scope="scope">{{scope.row.mobile | valueIsNull}}</template>
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
          fixed="right"
          :width="require('@/config/enum').opr_width2"
        >
          <template slot-scope="scope">
            <el-button @click="staffSummary(scope.row.id)">人员画像</el-button>
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout=" sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
// 引入富文本title汉字
import { excelDownload } from '../../../config/download.js'
/**
 *@ClassName:propertyManageList
 *@Description:物业人员管理
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-03-17
 */

export default {
  name: '/manage/main.staff',
  data() {
    return {
      fileLists: '',
      image: '',
      fileList: [
        {
          name: '',
          url: ''
        }
      ], // 上传
      input: '',
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      propertyManageListCheckbox: require('@/config/enum')
        .propertyManageListCheckbox // 是否隐藏复选框
    }
  },
  created() {
    setTimeout(() => {
    window.localStorage.setItem('wyform', '')
    window.localStorage.setItem('wysaveData', '')
    window.localStorage.setItem('wyradioSaveData', '')
    window.localStorage.setItem('wyauthoritySaveData', '')
    window.localStorage.setItem('wyrolesaveData', '')
    window.localStorage.setItem('wypermissionsaveData', '')
    window.localStorage.setItem('wyunitsaveData', '')
    window.localStorage.setItem('wyauthorityList', '')
    window.localStorage.setItem('wypermissionlist', '')
    window.localStorage.setItem('wyrolelist', '')
    }, 200)
    this.fileList = []
    this.getTablelist()
  },
  activated() {
    this.fileList = []
    this.getTablelist()
  },
  methods: {
    // 上传文件的断网
    uploadErr1() {
        if (!navigator.onLine || window.navigator.onLine === false) {
            const loading = this.$loading()
            setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
            }, 500)
        }
    },
    handleSuccess(e) {
      this.fileLists = e.raw
    },
    // 移除文件
    handleRemove() {
      this.fileList = []
      this.fileLists.length = 0
    },
    // 图片上传数量超过提醒
    outlimit() {
      this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
    },
    // 导入业主按钮
    submitUpload() {
      if (this.fileLists.length < 1) {
        this.$message.warning(this.$i18n.t('lang.key_up_file'))
      } else {
        let formData = new FormData()
        formData.append('excelFile', this.fileLists)
        let loading = this.$loading()
        this.$postFormData(`/inputStaff`, formData).then(
          res => {
            loading.close()
            this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
            this.fileList = []
            this.commit()
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      }
    },
    // 报表下载
    excelDownloadClick() {
      // Excel表头
      const tHeader = [
        this.$i18n.t('lang.lbl_duties_note'),
        this.$i18n.t('lang.lbl_duties_mobile')
      ]
      // 对应table数据的列字段名
      const filterVal = ['idNo', 'mobile']
      excelDownload(
        tHeader,
        filterVal,
        this.tableData,
        this.$i18n.t('lang.lab_propertyStaffManagement')
      )
    },
    // 下载模板
    download() {
      window.open(require('@/config/enum').mouldwy)
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    // 物业人员管理
    getTablelist() {
      let loading = this.$loading()
      this.$get(
        `/staffs?pageSize=${this.pageSize}&pageNo=${this.pageNo}&gardenId=${this.$store.getters.gardenId}&keyword=${this.input.trim()}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    edit(id) {
      window.localStorage.setItem('wyform', '')
      window.localStorage.setItem('wysaveData', '')
      window.localStorage.setItem('wyradioSaveData', '')
      window.localStorage.setItem('wyauthoritySaveData', '')
      window.localStorage.setItem('wyrolesaveData', '')
      window.localStorage.setItem('wypermissionsaveData', '')
      window.localStorage.setItem('wyunitsaveData', '')
      window.localStorage.setItem('wyauthorityList', '')
      window.localStorage.setItem('wypermissionlist', '')
      window.localStorage.setItem('wyrolelist', '')
      this.$router.push({ name: 'addpropertyManage', query: { id: id } })
    },
    add() {
      window.localStorage.setItem('wyform', '')
      window.localStorage.setItem('wysaveData', '')
      window.localStorage.setItem('wyradioSaveData', '')
      window.localStorage.setItem('wyauthoritySaveData', '')
      window.localStorage.setItem('wyrolesaveData', '')
      window.localStorage.setItem('wypermissionsaveData', '')
      window.localStorage.setItem('wyunitsaveData', '')
      window.localStorage.setItem('wyauthorityList', '')
      window.localStorage.setItem('wypermissionlist', '')
      window.localStorage.setItem('wyrolelist', '')
      this.$router.push({ name: 'addpropertyManage' })
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    // 物业人员画像
    staffSummary(id) {
      this.$router.push({ name: 'staffSummary', query: { id: id } })
    },
  }
}
</script>

<style lang="scss">
.propertyManageList .filters .el-input__inner {
  width: 240px;
}
.propertyManageList .upload-demo {
  display: inline;
  padding-left: 20px;
}
</style>
